import { render, staticRenderFns } from "./SectionCardIcon.vue?vue&type=template&id=2f014ffc&"
import script from "./SectionCardIcon.vue?vue&type=script&lang=ts&"
export * from "./SectionCardIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports